import React from "react";
import { useNavigate } from "react-router-dom";
import { USER_ROLES } from "@/data/models";

interface SidebarProps {
  currentRole: string;
  onNavigate?: (view: string) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ currentRole }) => {
  const navigate = useNavigate();

  const supervisorLinks = [
    { name: "Dashboard", path: "/supervisor-dashboard" },
    {
      name: "Pending Approval",
      path: "/supervisor-dashboard/pending-approval",
    },
    {
      name: "Completed Valuations",
      path: "/supervisor-dashboard/completed-valuations",
    },
    { name: "Reports", path: `/supervisor-dashboard/reports` },
    // { name: "Admin", isTitle: true },
    // { name: "Manage Users", path: "/supervisor-dashboard/manage-users" },
    // { name: "System Settings", path: "/supervisor-dashboard/system-settings" },
  ];

  const clientLinks = [
    { name: "Dashboard", path: "/client-dashboard" },
    { name: "Data", path: "/client-dashboard/my-properties" },
    { name: "Reports", path: "/client-dashboard/reports" },
  ];

  const collectorLinks = [
    { name: "Dashboard", path: "/data-dashboard" },
    { 
      name: "New Valuation", 
      path: "/data-dashboard/new-valuation",
      clearStorage: true // Add a flag to identify this link
    },
    { name: "My Assignments", path: "/data-dashboard/my-assignments" },
  ];

  const links =
    currentRole === USER_ROLES.SUPERVISOR
      ? supervisorLinks
      : currentRole === USER_ROLES.CLIENT
      ? clientLinks
      : collectorLinks;

  const handleNavigation = (link: any) => {
    // Clear localStorage if this is the New Valuation link
    if (link.clearStorage) {
      localStorage.removeItem("valuation-form-storage");
      console.log("Cleared valuation-form-storage from localStorage");
      
      // Navigate first, then reload
      navigate(link.path);
      
      // Force a page reload to ensure clean state
      setTimeout(() => {
        window.location.reload();
      }, 100); // Small delay to ensure navigation happens first
      
      return; // Prevent double navigation
    }
    
    // Regular navigation for other links
    navigate(link.path);
  };

  return (
    <aside className="w-64 text-black flex-shrink-0">
      <nav className="p-4 space-y-2">
        {links.map((link: any) =>
          link.isTitle ? (
            <div
              key={link.name}
              className="mt-4 text-gray-400 uppercase text-xs font-semibold"
            >
              {link.name}
            </div>
          ) : (
            <button
              key={link.name}
              onClick={() => handleNavigation(link)}
              className="block w-full text-left py-2 px-3 rounded hover:bg-gray-100 hover:text-primary-600 hover:font-semibold transition-colors duration-200"
            >
              {link.name}
            </button>
          )
        )}
      </nav>
    </aside>
  );
};

export default Sidebar;